import {axiosService} from "./axios.service";
import {endPoints} from "../configs/urls";

const additionalServicesService = {
    getByServiceType: async (service_type) => {
        try {
            const res = await axiosService.get(endPoints.additionalServices.base, {
                params: {
                    service_type,
                }
            });

            return res;
        } catch (error) {
            throw error;
        }
    }
}

export {
    additionalServicesService
}
